import { getPersistedQueryOptions } from '#pplx/frontend/react-query/internal/getPersistedQueryOptions.js';
export function prefetchPersistedQuery({ queryClient, options, allowPersist, }) {
    return queryClient.prefetchQuery(getPersistedQueryOptions({ options, queryClient, allowPersist }));
}
//# sourceMappingURL=prefetchQuery.js.map